import { POP_UP_BROWSER_CLASS_NAME } from './constants';

export const isInPopUpBrowser = () =>
	Boolean(typeof window !== 'undefined' && sessionStorage.getItem(POP_UP_BROWSER_CLASS_NAME));
